// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4567":"ebf953e7","6284":"31cfa795"}[chunkId] + ".chunk.css";
};